import { WORKSPACE_ACCESS_LEVEL } from './const';

const WORKSPACE_ACCESS_LEVEL_LABEL = {
  [WORKSPACE_ACCESS_LEVEL.allWorkspaces]: 'All workspaces',
  [WORKSPACE_ACCESS_LEVEL.onlyCurrentWorkspace]: 'Only current workspace',
};
export const getWorkspaceAccessLevelLabel = (level) => WORKSPACE_ACCESS_LEVEL_LABEL[level];
